// Languages
export const DEFAULT_LANGUAGE = "es";
export const FALLBACK_LANGUAGE = "es";
export const SUPPORTED_LANGUAGES = ["es", "en"];
